const getReferralSourceName = ({ patient, referralSource, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (referralSource && referralSource['Name of source']) {
    return referralSource['Name of source'];
  }
  if (patient['Referral Source'][0]) {
    return patient['Referral Source'][0]['Name of source'];
  }
  return null;
};

export default getReferralSourceName;



// WEBPACK FOOTER //
// ./src/utils/print/getReferralSourceName.js